import { DELETE_API } from "../../Functionalities/APIs";
import { reviewReviewUrl } from "../../Constants/apiUrls";

export const ManageReviewDelete = async (e, data, keyword, params) => {
    let function_name = "Delete Review"
    // void 0
    let path = reviewReviewUrl
    if (keyword == "delete") {
        let result = DELETE_API("", params, path);
        // void 0
        return await result.then((result) => {
            // void 0
            if (result) {
                // void 0
                return result;
            } else {
                return 0;
            }
        });
    }
}